import React, { useEffect } from 'react'
import { LABEL_WEIGHT } from '../../../components/label/constants';
import styles from "./FormsListing.styles"
import RichGrid from '../../../components/richgrid/RichGrid';
import FormListingFilters from './formlistingfilters/FormListingFilters';
import { componentKey, setCalculateTaxFeeModalOpen, setChangeScheduleDateForAllVendor, setDeleteFormsModalOpen, setFormDetailsDrawerOpen, setHighlightedForm, setIsAllCheckBoxChecked, setIsCheckBoxChecked, setPaginationState, setPrepayModalOpen, setReadyToSubmitTabCheckboxes, setSelectedForms, setSelectedTaxYear, setSubmitForThisPayerModal, setSubmitFormForMultiplePayers, setSumOfAllBoxAmountModalOpen, setLoadFormsDataState, setSubmitForThisPayerWarningModal, setSubmitForThisPayerReviewedCheckbox, setSubmitForThisPayerReviewedCheckboxModal, setAssignFormsToReviewersModal, setFormType, setFillingType, setLoadingState, setOpen1094cModal, updateForm1094cStatusObj, setCheckFor1094cStatus, setFeeData, setSubmittedForms, setViewTin, setSubmitForRecipientPendingModal, setOpen2023PaymentModal, setShouldGetSubmittedFormsGridData } from './FormListingSlice';
import Loadable from '../../../components/loadable/Loadable';
import Label from '../../../components/label/Label';
import useGarbageCollector from '../../../../libs/garbagecollector/garbageCollectorHooks';
import IconDropdown from '../../../components/dropdown/icondropdown/IconDropdown';
import FormDetailsDrawer from './formdetailsdrawer/FormDetailsDrawer';
import { useDispatch, useSelector } from 'react-redux';
import { ROW_SELECTION_OPTIONS } from '../../../components/richgrid/constants';
import { assignFormToReviewers, calculateTax1099FeeAmount, clearList, createZipForDownloadAll, deleteForms, deleteSingleForm, downloadMultiplePDF, downloadSinglePDF, exportToExcel, getEnableScheduleDate, getForm1094CStatus, getFormDetails, getFormsList, getPayersBySelectedForm, getSubmittedForms, getTaxYears, loadFormsData, submitForSinglePayer, updateReadyToSubmitTabCheckboxes } from './FormListingSaga';
import { FORM_LISTING_LOADING_STATES, FORM_LISTING_MESSAGE_MAP, LOAD_FORMS_DATA_STATE, READY_TO_SUBMIT_CHECKBOX } from './constants';
import CalculateTax1099Fee from './calculatetax1099fee/CalculateTax1099Fee';
import Button from '../../../components/button/Button';
import CheckboxWLabel from "../../../components/checkbox/checkboxwlabel/CheckboxWLabel";
import Checkbox from '../../../components/checkbox/basecheckbox/Checkbox';
import ConfirmationPopup from '../../../components/popup/confirmationpopup/ConfirmationPopup';
import { VEC_ICON_NAME } from '../../../components/icons/constants';
import { BUTTON_TYPE } from '../../../components/button/constants';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import Payer from '../../../../libs/utility/Payer';
import SumOfAllBoxAmount from './sumofallboxamount/SumOfAllBoxAmount';
import ChangeScheduleDateModal from './changescheduledate/ChangeScheduleDateModal';
import SubmitFormForMultiplePayers from './submitformformultiplepayers/SubmitFormForMultiplePayers';
import PaymentDrawer from '../../components/paymentdrawer/PaymentDrawer';
import { PAYMENT_STEPS } from '../../components/paymentdrawer/constants';
import PaymentDataService from '../../../../services/PaymentDataService';
import Popup from '../../../components/popup/Popup';
import AssignMembersTable from '../../components/addpayernew/assignmembers/assignmemberstable/AssignMembersTable';
import { isAccessAllowed } from '../../dashboard/hooks/userHooks';
import { PAGE_PATH, PAGE_PERMISSIONS } from '../../dashboard/constants/constant';
import { ShowForAllowedPermissionsOnly } from '../../wrappers/ShowForAllowedPermissionsOnly';
import { PermissionReroute, useUserPermissionsInfo } from '../../dashboard/hooks/userHooks';
import Form1094c from '../../components/form1094c/Form1094c';
import { FORM_IDS, FORM_SECTION_CONSTANTS, QUERY_PARAMS, QUERY_PARAMS_VALUE, TIN_STATUS, USER_ALLOWED_FEATURES, VIEW_TIN_CHECKBOX_MESSAGE } from '../constants';
import { setSubmitFormFees } from './FormListingSlice';
import General from '../../../../libs/utility/General';
import { componentKey as dataLoaderKey } from '../../loaders/dataloader/DataLoaderSlice';
import DateUtils from '../../../../libs/utility/DateUtils';
import { componentKey as dashboardComponentKey, setShowPaymentNotAllowedPopup } from '../../dashboard/DashboardSlice';
import Icons from '../../../components/icons/Icons';
import useTxSearchParams from '../../../../libs/txsearchparams/TxSearchParamsHook';
import useTxNavigate from '../../../../libs/txnavigate/TxNavigateHook';
import InformationPopup from '../../../components/popup/informationpopup/InformationPopup';
import Forms from '../../../../libs/utility/formsutility/Forms';
import { FILING_HISTORY_VALUE, HISTORY_QUERY_PARAMS, HISTORY_SECTION_ROUTES } from '../../history/Constants';
import { ShowForAllowedUsersOnly } from '../../wrappers/ShowForAllowedUsersOnly';
import { componentKey as authenticationComponentKey } from '../../authentication/AuthenticationSlice';

 export default function FormsListing() {
    
    useGarbageCollector(componentKey);

    const dispatch = useDispatch();
    const navigate = useTxNavigate();
    const [queryParams, setQueryParams] = useTxSearchParams();

    const { forms94xList } = useSelector(state => state[dataLoaderKey]);
    const { IsTinUnmaskAllowed } = useSelector(state => state[dashboardComponentKey])
    const { signedInUser } = useSelector((state) => state[authenticationComponentKey])

    const { 
        submittedForms, 
        submitForRecipientPendingModal, 
        loadingState, 
        paginationState, 
        taxYearsList, 
        selectedForm, 
        selectedTaxYear, 
        calculateTaxFeeModalOpen, 
        selectedPayer, 
        selectedReadyToSubmitForms, 
        deleteFormsModal, 
        fromDetailsDrawerOpen, 
        highlightedForm, 
        formDetails, 
        submittedFormsDetails, 
        readyToSubmitTabCheckboxes, 
        sumOfAllBoxAmountModalOpen, 
        feeData, 
        changeScheduleDateForAllVendor, 
        prepayModalOpen, 
        submitForThisPayerOpen, 
        formType, 
        submitFormFees, 
        loadFormsDataState, 
        fillingType, 
        formStatus,
        recipientName,
        recipientTIN,
        submitFormForMultiplePayers, 
        categorisedFormFields, 
        submitForThisPayerWarningModal, 
        submitForThisPayerReviewedCheckboxModal, 
        submitForThisPayerReviewedCheckbox, 
        assignFormsToReviewersModal, 
        formDetailsDrawerLoader, 
        open1094cModal, 
        form1094cStatusObj, 
        checkFor1094cStatus, 
        isTINHidden,
        open2023PaymentModal,
        shouldGetSubmittedFormsGridData,
        enableScheduleDate,
        filtersLoadingState,
        isFormGridLoading,
    } = useSelector(state => state[componentKey]);

    const { PendingCount, IrsRejectedCount, SubmittedCount } = submittedFormsDetails?.RecordCount;

    const { permissions } = useUserPermissionsInfo();

    useEffect(() => {
        PermissionReroute(PAGE_PERMISSIONS.VIEW_FORM, permissions, navigate, PAGE_PATH.DASHBOARD)
    }, [permissions])

    useEffect(()=>{
        if(!selectedTaxYear?.ID){
            return
        }

        dispatch(getEnableScheduleDate({
            formId: selectedForm?.value || "",
            taxYear: selectedTaxYear?.ID || "",
        }))
    },[selectedForm, selectedTaxYear])


    useEffect(() => {
        if (selectedForm?.label !== "" && selectedPayer?.label !== "" && selectedTaxYear?.label !== "") {
            handleGetSubmittedForms(paginationState?.page, paginationState?.pageSize, true)
            dispatch(setSelectedForms([]))
        }
    }, [selectedPayer, selectedForm, selectedTaxYear]);

    useEffect(() => {
        if(shouldGetSubmittedFormsGridData.gridData){
            handleGetSubmittedForms(paginationState?.page, paginationState?.pageSize, shouldGetSubmittedFormsGridData?.updatePagination ?? false)
            dispatch(setShouldGetSubmittedFormsGridData({
                gridData: false,
                updatePagination: false,
            }))
        }
    }, [shouldGetSubmittedFormsGridData])

    useEffect(() => {

        if (loadFormsDataState.state) {
            if (loadFormsDataState.type == LOAD_FORMS_DATA_STATE.SINGLE) {
                dispatch(submitForSinglePayer({ 
                    PayerId: selectedPayer?.value, 
                    FormName: selectedForm?.label, 
                    readyToSubmitTabCheckboxes, 
                    IsCorrected: formType?.value == "G" ? "Yes" : "No", 
                    TaxYear: selectedTaxYear?.value, 
                    PayerName: selectedPayer?.label, 
                    selectedReadyToSubmitForms: selectedReadyToSubmitForms?.length ? selectedReadyToSubmitForms : [highlightedForm], 
                    submittedForms, 
                    fromDrawer: loadFormsDataState?.fromDrawer, 
                    highlightedForm: highlightedForm,
                    considerAllSelectedFormsForThisPayer: loadFormsDataState?.considerAllSelectedFormsForThisPayer,
                }));
            } else if (loadFormsDataState.type == LOAD_FORMS_DATA_STATE.MULTIPLE) {
                dispatch(setSubmitFormForMultiplePayers(true));
                dispatch(setLoadingState({ state: FORM_LISTING_LOADING_STATES.FETCHING_LOAD_FORMS_DATA_READY }))
            }
            else if (loadFormsDataState.type == LOAD_FORMS_DATA_STATE.CALCULATE_TAX_1099_FEE) { 
                dispatch(submitForSinglePayer({
                    PayerId: selectedPayer?.value,
                    FormName: selectedForm?.label,
                    readyToSubmitTabCheckboxes,
                    IsCorrected: formType?.value == "G" ? "Yes" : "No",
                    TaxYear: selectedTaxYear?.value,
                    PayerName: selectedPayer?.label,
                    selectedReadyToSubmitForms: selectedReadyToSubmitForms?.length ? selectedReadyToSubmitForms : [highlightedForm],
                    submittedForms,
                    fromDrawer: loadFormsDataState?.fromDrawer,
                    openSubmitForThisPayerModal: false,
                    highlightedForm: highlightedForm,
                }));

                if (loadFormsDataState?.fromDrawer === false) {
                    dispatch(setCalculateTaxFeeModalOpen(true));
                }
            }

            if (loadFormsDataState?.fromVerificationPopup) {
                dispatch(setSubmitForThisPayerReviewedCheckboxModal(false));
                dispatch(setSubmitForThisPayerReviewedCheckbox(false));
            }

            dispatch(setLoadFormsDataState({ state: false, type: "" }))
        }

    }, [loadFormsDataState]);

    useEffect(() => {
        const urlFormId = queryParams.get('FormId');
        const urlFormType = queryParams.get('FormType');
        const urlFilingType = queryParams.get('FilingType');

        if (urlFormType == QUERY_PARAMS_VALUE.CORRECTED) {
            dispatch(setFormType({ label: QUERY_PARAMS_VALUE.CORRECTED, value: "G" }))
        } else {
            dispatch(setFormType({ label: "Regular", value: "" }))
        }

        if (urlFilingType == "false") {
            dispatch(setFillingType({ label: "Federal Filing", value: false }))
        } else if (urlFilingType == "true") {
            dispatch(setFillingType({ label: "State Filing", value: true }))
        } else {
            dispatch(setFillingType({ label: "", value: "" }))
        }

        dispatch(clearList());
        dispatch(getFormsList({ formId: urlFormId }));
    }, []);

    useEffect(() => {
        if (selectedForm.value) {
            const urlTaxYear = queryParams.get('TaxYear');
            const urlPayerId = queryParams.get('PayerId');

            queryParams.set('FormId', selectedForm.value);
            setQueryParams(queryParams);
            dispatch(setSubmittedForms([]));
            dispatch(getTaxYears({ formId: selectedForm.value, taxYear: urlTaxYear }));
            dispatch(getPayersBySelectedForm({ formId: selectedForm.value, payerId: urlPayerId }));
        }
    }, [selectedForm]);

    useEffect(() => {
        if (selectedPayer?.value) {
            queryParams.set("PayerId", selectedPayer?.value);
        }

        setQueryParams(queryParams);
    }, [selectedPayer]);

    useEffect(() => {
        if (checkFor1094cStatus) {
            if (selectedForm?.FormId === FORM_IDS.$1095C && submittedForms.length > 0) {
                dispatch(getForm1094CStatus({ payerId: selectedPayer?.value }));
            } else {
                if (form1094cStatusObj?.isAvailable) {
                    dispatch(updateForm1094cStatusObj({
                        isAvailable: false,
                        formStatus: null,
                    }))
                }
            }
            dispatch(setCheckFor1094cStatus(false))
        }
    }, [checkFor1094cStatus]);
    
    const handleGetSubmittedForms = (pageNumber, pageSize, updatePagination = false) => {
        dispatch(getSubmittedForms({
            pageNumber: pageNumber,
            pageSize: pageSize,
            jsonPreferences: submittedForms?.length ? Forms.getJsonPreferences(submittedForms, submittedForms) : null,
            payerId: selectedPayer?.PayerDetailId,
            formId: selectedForm?.value,
            taxyear: selectedTaxYear?.ID,
            formname: selectedForm?.label,
            formType: formType?.value,
            statustype: formStatus?.value,
            filingType: fillingType?.value,
            payeeName: recipientName || "",
            payeeTIN: recipientTIN ? General.removeDashesFromString(recipientTIN) : "",
            readyToSubmitTabCheckboxes: readyToSubmitTabCheckboxes,
        }))

        if(updatePagination){
            dispatch(setPaginationState({ page: 1, Skip: 0 }));
        }
    }

    const ACTION_BUTTOM_DROWDOWN_ITEM = [
        ...(fromDetailsDrawerOpen || General.is94xForm(forms94xList, selectedForm.label) ? [] : [
            {
                itemName: "Download Multiple PDF",
                onClick: () => {
                    if (selectedReadyToSubmitForms?.length || Object.keys(highlightedForm)?.length !== 0) {
                        dispatch(createZipForDownloadAll({ payer: selectedPayer, formName: selectedForm.label, taxYear: selectedTaxYear.label, submittedForms, selectedReadyToSubmitForms, maskTin: IsTinUnmaskAllowed ? isTINHidden : true }));
                    } else {
                        dispatch(addNotifications({ heading: "To continue, please select a form!", message: "To donwload multiple PDFs, please select a form" }));
                    }
                },
            },
        ]),
        {
            itemName: "Calculate Tax1099.com Fee",
            onClick: () => {
                if (selectedReadyToSubmitForms?.length || Object.keys(highlightedForm)?.length !== 0) {
                    dispatch(loadFormsData({ PayerId: selectedPayer?.value, selectedForm, TaxYear: selectedTaxYear?.value, filingType: fillingType?.value || false, submitType: LOAD_FORMS_DATA_STATE.CALCULATE_TAX_1099_FEE, formType, fromVerificationPopup: false, fromDrawer: false }));
                } else {
                    dispatch(addNotifications({ heading: "To continue, please select a form!", message: "To calculate Tax1099.com fee, please select a form" }));
                }
            },
        },
        ...(isAccessAllowed(PAGE_PERMISSIONS.SUBMIT_TO_FORMS_PAGE_FORMS) && !General.disablePaymentFeature(selectedTaxYear?.value, selectedForm?.FormShortName) ? [{
            itemName: "Submit for this Payer",
            onClick: () => {
                if(isAccessAllowed(PAGE_PERMISSIONS.PAYMENTS, permissions )) {
                    if (selectedReadyToSubmitForms?.length) {
                        dispatch(loadFormsData({ PayerId: selectedPayer?.value, selectedForm, TaxYear: selectedTaxYear?.value, filingType: fillingType?.value || false, submitType: LOAD_FORMS_DATA_STATE.SINGLE, formType, fromDrawer: false, considerAllSelectedFormsForThisPayer: true }))
                    } else {
                        dispatch(addNotifications({ heading: "To continue, please select a form!", message: "Form not selected" }));
                    }
                } else {
                    dispatch(setShowPaymentNotAllowedPopup(true))
                }

            }
        }] : []),
        {
            itemName: "Sum of all box amount",
            onClick: () => {
                if (selectedForm?.label !== "" && selectedPayer?.label !== "" && selectedTaxYear?.label || Object.keys(highlightedForm)?.length !== 0) {
                    dispatch(setSumOfAllBoxAmountModalOpen(true));
                } else {
                    dispatch(addNotifications({ heading: "Error", message: "To continue, please select a form!" }));
                }
            },
        },
        {
            itemName: "Delete",
            onClick: () => {
                if (selectedReadyToSubmitForms?.length) {
                    dispatch(setDeleteFormsModalOpen({ state: true, fromDrawer: false }));
                } else {
                    dispatch(addNotifications({ heading: "To continue, please select a form!", message: "To delete multiple forms, please select at least one form" }));
                }
            },
            permissions: PAGE_PERMISSIONS.DELETE_FORM
        },
    ];

    const DRAWER_ACTION_BUTTONS = [
        {
            itemName: "Calculate Tax1099.com Fee",
            onClick: () => {
                if (Object.keys(highlightedForm)?.length !== 0) {
                    dispatch(setCalculateTaxFeeModalOpen(true));
                } else {
                    dispatch(addNotifications({ heading: "To continue, please select a form!", message: "To calculate Tax1099.com fee, please select a form" }));
                }
            },
        },
        {
            itemName: "Sum of all box amount",
            onClick: () => {
                if (Object.keys(highlightedForm)?.length !== 0) {
                    dispatch(setSumOfAllBoxAmountModalOpen(true));
                } else {
                    dispatch(addNotifications({ heading: "To continue, please select a form!", message: "To calculate sum of all box amount, select a form" }));
                }
            },
        },
        {
            itemName: "View PDF", onClick: () => {
                if (Object.keys(highlightedForm)?.length !== 0) {
                    dispatch(downloadSinglePDF({ highlightedForm, selectedForm, selectedPayer, viewOnly: true, isUnMask: IsTinUnmaskAllowed ? !isTINHidden : false }))
                } else {
                    dispatch(addNotifications({ heading: "Error", message: "To view a PDF, please select a form" }));
                }
            }
        },
        {
            itemName: "Download PDF", onClick: () => {
                if (Object.keys(highlightedForm)?.length !== 0) {
                    dispatch(downloadSinglePDF({ highlightedForm, selectedForm, selectedPayer, isUnMask: IsTinUnmaskAllowed ? !isTINHidden : false }))
                } else {
                    dispatch(addNotifications({ heading: "Error", message: "To download a PDF, please select a form" }));
                }
            }
        },
        ...(isAccessAllowed(PAGE_PERMISSIONS.SUBMIT_TO_FORMS_PAGE_FORMS) && !General.disablePaymentFeature(selectedTaxYear?.value, selectedForm?.FormShortName) ? [{
            itemName: "Submit for this payer",
            onClick: () => {

                if (Object.keys(highlightedForm)?.length !== 0) {
                    dispatch(loadFormsData({ PayerId: selectedPayer?.value, selectedForm, TaxYear: selectedTaxYear?.value, filingType: fillingType?.value || false, submitType: LOAD_FORMS_DATA_STATE.SINGLE, formType, fromDrawer: true, considerAllSelectedFormsForThisPayer: true }))
                } else {
                    dispatch(addNotifications({ heading: "To continue, please select a form!", message: "Form not selected" }));
                }

            }
        }] : []),
        {
            itemName: "Edit",
            onClick: () => {
                navigate(`/forms/createnew?FormName=${selectedForm?.FormShortName}&Year=${selectedTaxYear?.value}&FormRecordId=${highlightedForm.FormId}&page=${FORM_SECTION_CONSTANTS.SUBMIT_FORMS}&${QUERY_PARAMS.ALLOW_PAYER_RECIPIENT_SELECTION}=true`)
            },
            permissions: PAGE_PERMISSIONS.EDIT_FORM
        },
        {
            itemName: "Delete",
            onClick: () => {
                if (selectedReadyToSubmitForms?.length || Object.keys(highlightedForm)?.length !== 0) {
                    dispatch(setDeleteFormsModalOpen({ state: true, fromDrawer: true }));
                } else {
                    dispatch(addNotifications({ heading: "To continue, please select a form!", message: "To delete multiple forms, please select at least one form" }));
                }
            },
            permissions: PAGE_PERMISSIONS.DELETE_FORM
        },
    ]

    const FORM_LISTING_COLUMNS = [
        {
            field: "date",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={{ ...styles.text, ...styles.date }}>Date</Label>,
            renderLogic: (row, idx) => <span style={{ ...styles.text, ...styles.date }}>{row.Date}</span>
        },
        {
            field: "tin",
            header: <Label weight={LABEL_WEIGHT[700]}>TIN</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{Payer.getPayerTINByIdType(row.TINType, row.TIN, isTINHidden)}</span>
        },
        {
            field: "name",
            header: <Label weight={LABEL_WEIGHT[700]}>Name</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{row.Name}</span>
        },
        {
            field: "amount",
            header: <Label weight={LABEL_WEIGHT[700]}>Amount ($)</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{row.Amount}</span>
        },
        {
            field: "recipientEmail",
            header: <Label weight={LABEL_WEIGHT[700]}>Recipient Email</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{row.RecipientEmail}</span>
        },
        {
            field: "uspsMail",
            header: <CheckboxWLabel
                name='IsUSPSMail'
                label="USPS Mail"
                checked={submittedForms?.every(item => item?.IsUSPSMail) || readyToSubmitTabCheckboxes?.uspsMailCheckbox}
                disabled={General.is94xForm(forms94xList, selectedForm.label)}
                onChangeCb={({ target: { name, checked } }) => dispatch(setIsAllCheckBoxChecked({ name, checked }))} weight={LABEL_WEIGHT[700]} />,
            renderLogic: (row, idx) => <span style={styles.text}>
                <Checkbox
                    name="IsUSPSMail"
                    checked={row.IsUSPSMail}
                    disabled={General.is94xForm(forms94xList, selectedForm.label)}
                    onChangeCb={({ target: { name, checked } }) => {
                        dispatch(setIsCheckBoxChecked({ name: name, checked: checked, index: idx }))
                    }}
                />
            </span>
        },
        {
            field: "emailRecipient",
            header: <CheckboxWLabel
                name='IsEmailRecipient'
                label="eDelivery"
                checked={submittedForms?.some(item => item?.IsEmailRecipient) || readyToSubmitTabCheckboxes?.emailRecipientCheckbox}
                onChangeCb={({ target: { name, checked } }) => dispatch(setIsAllCheckBoxChecked({ name, checked }))}
                disabled={General.is94xForm(forms94xList, selectedForm.label) || submittedForms?.every(item => item?.RecipientEmail == "No email address")}
                weight={LABEL_WEIGHT[700]}
                iconName={VEC_ICON_NAME.CHECKBOX_DASH_ICON}
            />,
            renderLogic: (row, idx) => <span style={styles.text}>
                <Checkbox
                    name='IsEmailRecipient'
                    checked={row.IsEmailRecipient}
                    onChangeCb={({ target: { name, checked } }) => dispatch(setIsCheckBoxChecked({ name, checked, index: idx }))}
                    disabled={General.is94xForm(forms94xList, selectedForm.label) || row?.RecipientEmail == "No email address" || !row?.TIN}
                />
            </span>
        },
        {
            field: "tinMatch",
            header: <CheckboxWLabel
                name='IsTinCheck'
                label="TIN Match"
                checked={submittedForms?.some(item => item?.IsTinCheck) || readyToSubmitTabCheckboxes?.tinMatchCheckbox}
                onChangeCb={({ target: { name, checked } }) => dispatch(setIsAllCheckBoxChecked({ name, checked }))}
                weight={LABEL_WEIGHT[700]}
                disabled={General.is94xForm(forms94xList, selectedForm.label) || submittedForms?.every(item => !item?.TIN)}
                iconName={VEC_ICON_NAME.CHECKBOX_DASH_ICON}
            />,
            renderLogic: (row, idx) => <span style={{...styles.text, ...styles.flexRowWithGap}}>
                <Checkbox
                    name='IsTinCheck'
                    checked={row.IsTinCheck}
                    onChangeCb={({ target: { name, checked } }) => dispatch(setIsCheckBoxChecked({ name: name, checked: checked, index: idx }))}
                    disabled={General.is94xForm(forms94xList, selectedForm.label) || !row?.TIN || row?.TinStatus === TIN_STATUS.PROCESSING}
                />
                {row?.TinStatus === TIN_STATUS.PROCESSING && row?.TinStatus}
            </span>
        },
        {
            field: "stateFiling",
            header: <CheckboxWLabel
                name='IsState'
                label="State Filing"
                checked={submittedForms?.some(item => item?.IsState) || readyToSubmitTabCheckboxes?.stateFilingCheckbox}
                onChangeCb={({ target: { name, checked } }) => dispatch(setIsAllCheckBoxChecked({ name, checked }))}
                weight={LABEL_WEIGHT[700]}
                disabled={General.is94xForm(forms94xList, selectedForm.label) || submittedForms?.every(item => !item?.IsState)}
                iconName={VEC_ICON_NAME.CHECKBOX_DASH_ICON}
            />,
            renderLogic: (row, idx) => <span style={{...styles.text, ...styles.flexRowWithGap }}>
                <Checkbox
                    name='IsState'
                    checked={row.IsState}
                    onChangeCb={({ target: { name, checked } }) => dispatch(setIsCheckBoxChecked({ name: name, checked: checked, index: idx }))}
                    disabled={ General.is94xForm(forms94xList, selectedForm.label) || !row?.State }
                />
                {row?.State}
            </span>
        },
        {
            field: "scheduledDate",
            header: <Label weight={LABEL_WEIGHT[700]}>Scheduled Date</Label>,
            renderLogic: (row, idx) => <span style={styles.text}>{ General.is94xForm(forms94xList, selectedForm.label) ? DateUtils.dateFormatter(new Date().toDateString(), 'MM/DD/YYYY') : row.ScheduleDropDown}</span>
        },
        {
            field: "operations",
            header: <Label Label weight={LABEL_WEIGHT[700]} >Operations</Label >,
            renderLogic: (row, idx) => <div style={styles.actionButtons}>
                <Button onClickCb={() => {
                    dispatch(setHighlightedForm(row));
                    dispatch(setSubmitFormFees({}))
                    dispatch(setFormDetailsDrawerOpen(true));
                    dispatch(loadFormsData({ PayerId: selectedPayer?.value, selectedForm, TaxYear: selectedTaxYear?.value, filingType: fillingType?.value || false, submitType: LOAD_FORMS_DATA_STATE.CALCULATE_TAX_1099_FEE, formType, fromVerificationPopup: false, fromDrawer: true }));
                }}>Actions</Button>
            </div>
        },
    ];

    const READY_TO_SUBMIT_TOP_COLUMNS = [
        {
            header: <CheckboxWLabel
                label={"Select All"}
                weight={LABEL_WEIGHT[700]}
                name={READY_TO_SUBMIT_CHECKBOX.SELECT_ALL}
                checked={readyToSubmitTabCheckboxes?.selectAllCheckBox}
                onChangeCb={(e) => {
                    dispatch(updateReadyToSubmitTabCheckboxes({ checkboxName: READY_TO_SUBMIT_CHECKBOX.SELECT_ALL, checkboxValue: e.target.checked }));
                    dispatch(setSelectedForms(e.target.checked ? submittedForms : []))
                }}
            />,
        },
       ...(IsTinUnmaskAllowed ? [ {
            header: <CheckboxWLabel
                label={<span title={VIEW_TIN_CHECKBOX_MESSAGE} className='fs-16'>View TIN <span><Icons familyName={"vec"} iconName={VEC_ICON_NAME.INFO_ICON} /></span></span>}
                checked={!isTINHidden}
                onChangeCb={() => dispatch(setViewTin())}
            />,
        }] : [{}]),
        {}, {}, {}, {},
        {
            header: <CheckboxWLabel
                label={"USPS Mail"}
                weight={LABEL_WEIGHT[700]}
                name={READY_TO_SUBMIT_CHECKBOX.USPS_MAIL}
                checked={readyToSubmitTabCheckboxes?.uspsMailCheckbox}
                disabled={General.is94xForm(forms94xList, selectedForm.label)}
                onChangeCb={(e) => {
                    dispatch(updateReadyToSubmitTabCheckboxes({ checkboxName: READY_TO_SUBMIT_CHECKBOX.USPS_MAIL, checkboxValue: e.target.checked }));

                    dispatch(setIsAllCheckBoxChecked({ name: "IsUSPSMail", checked: e.target.checked }));
                }}
            />,
        },
        {
            header: <CheckboxWLabel
                label={"eDelivery"}
                weight={LABEL_WEIGHT[700]}
                name={READY_TO_SUBMIT_CHECKBOX.EMAIL_RECIPIENT}
                checked={readyToSubmitTabCheckboxes?.emailRecipientCheckbox}
                disabled={General.is94xForm(forms94xList, selectedForm.label)}
                onChangeCb={(e) => {
                    dispatch(updateReadyToSubmitTabCheckboxes({ checkboxName: READY_TO_SUBMIT_CHECKBOX.EMAIL_RECIPIENT, checkboxValue: e.target.checked, selectAllCheckBox: readyToSubmitTabCheckboxes?.selectAllCheckBox }));

                    dispatch(setIsAllCheckBoxChecked({ name: "IsEmailRecipient", checked: e.target.checked }));
                }}
            />,
        },
        {
            header: <CheckboxWLabel
                label={"TIN Match"}
                weight={LABEL_WEIGHT[700]}
                name={READY_TO_SUBMIT_CHECKBOX.TIN_MATCH}
                checked={readyToSubmitTabCheckboxes?.tinMatchCheckbox}
                disabled={General.is94xForm(forms94xList, selectedForm.label)}
                onChangeCb={(e) => {
                    dispatch(updateReadyToSubmitTabCheckboxes({ checkboxName: READY_TO_SUBMIT_CHECKBOX.TIN_MATCH, checkboxValue: e.target.checked }))
                    dispatch(setIsAllCheckBoxChecked({ name: "IsTinCheck", checked: e.target.checked }));
                }}
            />,
        },
        {
            header: <CheckboxWLabel
                label={"State Filing"}
                weight={LABEL_WEIGHT[700]}
                name={READY_TO_SUBMIT_CHECKBOX.STATE_FILING}
                checked={readyToSubmitTabCheckboxes?.stateFilingCheckbox}
                disabled={General.is94xForm(forms94xList, selectedForm.label)}
                onChangeCb={(e) => {
                    dispatch(updateReadyToSubmitTabCheckboxes({ checkboxName: READY_TO_SUBMIT_CHECKBOX.STATE_FILING, checkboxValue: e.target.checked }));
                    dispatch(setIsAllCheckBoxChecked({ name: "IsState", checked: e.target.checked }));
                }}
            />
        }
    ]

    const { FETCHING_FORMS_LIST_LOADING, FETCHING_TAX_YEARS_LOADING, FETCHING_PAYERS_LOADING, FETCHING_FORM_LIST_LOADING, DELETE_BULK_FORM_LOADING, DELETE_SINGLE_FORM_LOADING, CREATE_ZIP_LOADING, DOWNLOAD_MULTIPLE_PDF_LOADING, EXPORT_TO_EXCEL_LOADING, FETCHING_LOAD_FORMS_DATA_LOADING, FETCHING_LOAD_FORMS_DATA_FROM_DRAWER_LOADING, SUBMIT_FOR_THIS_PAYER_LOADING  } = FORM_LISTING_LOADING_STATES;

    const FORM_FILTERS_LOADING_STATE = [FETCHING_FORMS_LIST_LOADING, FETCHING_TAX_YEARS_LOADING, FETCHING_PAYERS_LOADING];

    const GRID_LOADING_STATE = [FETCHING_FORM_LIST_LOADING, DELETE_BULK_FORM_LOADING, DELETE_SINGLE_FORM_LOADING, CREATE_ZIP_LOADING, DOWNLOAD_MULTIPLE_PDF_LOADING, FETCHING_LOAD_FORMS_DATA_LOADING, SUBMIT_FOR_THIS_PAYER_LOADING];

    return (

        <>
            <>
                <div style={styles.headerContainer}>
                    <Loadable
                        currentState={filtersLoadingState.state}
                        loadingStates={FORM_FILTERS_LOADING_STATE}
                        messageMap={FORM_LISTING_MESSAGE_MAP}
                        isNewLoadable={true}
                    >
                        <FormListingFilters />
                    </Loadable>
                </div>

                <Loadable
                    currentState={loadingState.state}
                    loadingStates={GRID_LOADING_STATE}
                    messageMap={FORM_LISTING_MESSAGE_MAP}
                    isNewLoadable={true}
                >
                    {!isFormGridLoading && selectedForm?.label !== "" && selectedPayer?.label !== "" && selectedTaxYear?.label !== "" && <>
                        {submittedForms?.length !== 0 && <div style={{ display: "flex", justifyContent: "end", columnGap: "10px", marginBottom: "30px" }}>

                            <Button
                                style={styles.button}
                                type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER}
                                onClickCb={() => {
                                        if(isAccessAllowed(PAGE_PERMISSIONS.PAYMENTS, permissions )) {
                                            dispatch(setPrepayModalOpen(true))
                                        } else {
                                            dispatch(setShowPaymentNotAllowedPopup(true))
                                        }
                                    }}>
                                Prepay
                            </Button>

                            <Loadable
                                currentState={loadingState.state}
                                loadingStates={[EXPORT_TO_EXCEL_LOADING]} isNewLoadable={true}
                                messageMap={FORM_LISTING_MESSAGE_MAP}
                                isFullWidth={false}
                            >
                                <Button
                                    style={styles.button}
                                    type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER}
                                    onClickCb={() => dispatch(exportToExcel({ selectedForm, selectedPayer, selectedTaxYear, formType }))}
                                >
                                    Export To Excel
                                </Button>
                            </Loadable>

                            <Button
                                style={styles.button}
                                type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER}
                                disabled={ General.is94xForm(forms94xList, selectedForm.label) || !enableScheduleDate }
                                onClickCb={() => {
                                    if (selectedPayer && selectedForm && selectedTaxYear) {
                                        dispatch(setChangeScheduleDateForAllVendor(!changeScheduleDateForAllVendor));
                                    } else {
                                        dispatch(addNotifications({ heading: "To continue, please select a payer, form and year!" }));
                                    }
                                }}>
                                Change Schedule Date For All Vendor Files To IRS
                            </Button>

                            <ShowForAllowedPermissionsOnly toCheck={PAGE_PERMISSIONS.SUBMIT_TO_FORMS_PAGE_FORMS}>
                                <ShowForAllowedUsersOnly allowedUsers={USER_ALLOWED_FEATURES.SUBMIT_FOR_MULTIPLE_PAYER} useTypeNumber={true} >
                                    {!signedInUser?.IsDisabledSubmitForMultiplePayer ? <Button
                                        style={styles.button}
                                        type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER}
                                        disabled={General.disablePaymentFeature(selectedTaxYear?.value, selectedForm?.FormShortName) || General.is94xForm(forms94xList, selectedForm.label) || General.isFormExist(General.MULTIPAYER_SUBMIT_DISABLED_FORMS, selectedForm?.FormName1)}
                                        onClickCb={() => {

                                            if (selectedPayer && selectedForm && selectedTaxYear) {
                                                dispatch(loadFormsData({ PayerId: selectedPayer?.value, selectedForm, TaxYear: selectedTaxYear?.value, filingType: fillingType?.value || false, submitType: LOAD_FORMS_DATA_STATE.MULTIPLE, formType, fromDrawer: false }))
                                            } else {
                                                dispatch(addNotifications({ heading: "To continue, please select a payer, form and year!" }));
                                            }

                                        }}>
                                        Submit for multiple payer
                                    </Button> : null}
                                </ShowForAllowedUsersOnly>
                            </ShowForAllowedPermissionsOnly>

                            <IconDropdown
                                label="Bulk Actions"
                                dropdownItems={ACTION_BUTTOM_DROWDOWN_ITEM}
                                dropdownContainerStyles={styles.actionDropdown}
                                styles={styles.actionDropdownLabel}
                                dropdownMenuStyle={styles.actionDropdownMenu}
                            />
                        </div>}
                        {
                            selectedForm?.FormId === FORM_IDS.$1095C && submittedForms.length > 0 && form1094cStatusObj?.isAvailable && <div>
                                <Label weight={700} customStyles={styles.label1094cStyle}>Form 1094-C</Label>
                                <Button
                                    type={BUTTON_TYPE.PRIMARY}
                                    style={{ ...styles.button1094c, ...(form1094cStatusObj?.formStatus ? styles.btnColorGreen : styles.btnColorRed) }}
                                    onClickCb={() => dispatch(setOpen1094cModal(true))}
                                >
                                    {form1094cStatusObj?.formStatus ? "Complete" : "INCOMPLETE"}
                                </Button>
                            </div>
                        }
                        <div style={styles.gridContainer}>
                            {!isFormGridLoading && submittedForms?.length ? <RichGrid
                                selectable={true}
                                data={submittedForms}
                                columns={FORM_LISTING_COLUMNS}
                                topHeaderColumns={READY_TO_SUBMIT_TOP_COLUMNS}
                                extractRowKey={(row) => row.FormId}
                                selectedRows={selectedReadyToSubmitForms}
                                onHeaderSelectionChangeCallBack={(selectedData) => dispatch(setSelectedForms(selectedData))}
                                onSelectionChangeCallBack={(selectedData) => dispatch(setSelectedForms(selectedData))}
                                paginationProps={{
                                    skip: paginationState?.Skip,
                                    take: paginationState?.pageSize,
                                    takeOptions: ROW_SELECTION_OPTIONS,
                                    total: paginationState?.total,
                                    onChangeTakeCb: (newTake) => {
                                        dispatch(setPaginationState({ ...paginationState, pageSize: newTake, page: 1, Skip: 0 }));
                                        handleGetSubmittedForms(1, newTake, false)
                                    },
                                    onChange: (take, skip) => {
                                        dispatch(setPaginationState({ ...paginationState, pageSize: take, Skip: skip, page: Math.ceil((take + skip) / take) }))
                                        handleGetSubmittedForms(Math.ceil((take + skip) / take), take, false)
                                    }
                                }}
                            /> : !isFormGridLoading && !submittedForms?.length && selectedForm?.label !== "" && selectedPayer?.label !== "" && selectedTaxYear?.label !== "" && <b style={{ display: "flex", justifyContent: "center" }}>No Data Found!</b>}
                        </div>
                    </>}
                </Loadable>

                {/* Form Details Drawer */}
                {fromDetailsDrawerOpen &&
                    <FormDetailsDrawer
                        isOpen={fromDetailsDrawerOpen}
                        title={`${selectedForm.label} Form Details`}
                        highlightedForm={highlightedForm}
                        onCloseCb={() => {
                            dispatch(setFormDetailsDrawerOpen(false));
                            dispatch(setHighlightedForm({}));
                        }}
                        actionDropdown={DRAWER_ACTION_BUTTONS}
                        formDetails={formDetails}
                        feeData={submitFormFees}
                        categorisedFormFields={categorisedFormFields}
                        onSubmitCb={() => dispatch(setSubmitForThisPayerReviewedCheckboxModal(true))}
                        submittedForms={submittedForms}
                        selectedForm={selectedForm}
                        selectedPayer={selectedPayer}
                        selectedTaxYear={selectedTaxYear}
                        fillingType={fillingType}
                        drawerLoader={formDetailsDrawerLoader}
                        showUnverifiedTinMessage={highlightedForm?.IsTinCheck}
                        loadingState={loadingState}
                    />
                }

                {deleteFormsModal?.state &&
                    <ConfirmationPopup
                        title={"Are you sure?"}
                        bodyText={`Are you sure you want to delete the selected forms?`}
                        iconName={VEC_ICON_NAME.WARNING_ICON}
                        isOpen={deleteFormsModal?.state}
                        confirmationButtonProps={{
                            onConfirmationCb: () => {
                                if (selectedReadyToSubmitForms?.length) {
                                    dispatch(deleteForms({ submittedForms, selectedReadyToSubmitForms, selectedForm, fromDrawer: deleteFormsModal?.fromDrawer }));
                                    dispatch(setDeleteFormsModalOpen({ state: false }))
                                } else {
                                    dispatch(deleteSingleForm({ formSubmissionId: highlightedForm.FormId, formId: selectedForm.value, fromDrawer: deleteFormsModal?.fromDrawer }));
                                    dispatch(setDeleteFormsModalOpen({ state: false }));
                                }
                            },
                            confirmationButtonText: "Delete",
                            confirmationButtonStyles: {},
                            confirmationButtonType: BUTTON_TYPE.PRIMARY,
                        }}
                        cancelButtonProps={{
                            onCancelCb: () => dispatch(setDeleteFormsModalOpen({ state: false })),
                            cancelButtonText: "Cancel",
                            cancelButtonStyles: {},
                            cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                        }}
                        showClose={false}
                    />
                }
            </>

            {
                calculateTaxFeeModalOpen &&
                <CalculateTax1099Fee
                    isOpen={calculateTaxFeeModalOpen}
                    onCloseCb={() => {
                        dispatch(setCalculateTaxFeeModalOpen(false));
                    }}
                    formsList={submittedForms}
                    feeData={submitFormFees}
                    selectedFormsList={selectedReadyToSubmitForms}
                    formName={selectedForm?.FormLabel}
                    payerData={selectedPayer}
                    taxYear={selectedTaxYear}
                />
            }

            {
                sumOfAllBoxAmountModalOpen &&
                <SumOfAllBoxAmount
                    isOpen={sumOfAllBoxAmountModalOpen}
                    onCloseCb={() => dispatch(setSumOfAllBoxAmountModalOpen(false))}
                    payerId={selectedPayer?.PayerDetailId}
                    taxYearId={selectedTaxYear?.label}
                    formId={selectedForm?.value}
                    status="NotSubmitted"
                    Corrected=""
                />
            }

            {
                changeScheduleDateForAllVendor &&
                <ChangeScheduleDateModal
                    isOpen={changeScheduleDateForAllVendor}
                    onCloseCb={() => dispatch(setChangeScheduleDateForAllVendor(!changeScheduleDateForAllVendor))}
                    payerId={selectedPayer?.PayerDetailId}
                    taxYearId={selectedTaxYear?.label}
                    formId={selectedForm?.value}
                    formName={selectedForm?.FormLabel}
                    status="NotSubmitted"
                    ReadyToSubmitForms={selectedReadyToSubmitForms}
                />
            }

            {
                prepayModalOpen &&
                <PaymentDrawer
                    isOpen={prepayModalOpen}
                    onCloseCb={() => dispatch(setPrepayModalOpen(false))}
                    defaultStep={PAYMENT_STEPS.ADD_FUNDS}
                />
            }

            {
                submitForThisPayerOpen &&
                <PaymentDrawer
                    isOpen={submitForThisPayerOpen}
                    onCloseCb={() => {
                        dispatch(setSubmitForThisPayerModal(false))
                        dispatch(setFormDetailsDrawerOpen(false));
                        dispatch(setHighlightedForm({}))
                    }}
                    fees={submitFormFees}
                    calculateEstimatedTax={true}
                    paymentServiceFunctionCb={submitFormFees?.submitForMultiplePayers ? PaymentDataService.submitAllPayersPayment : PaymentDataService.submitPayment}
                    onPaymentSuccessCb={() => handleGetSubmittedForms(paginationState?.page ?? 1, paginationState?.pageSize ?? 200, false)}
                    filingFeeLabel={`Form Submit ${selectedForm?.label}`}
                    showOnSuccessNavigationBtns={true}
                    onSuccessNavigationBtnsArr={[
                        {
                            label: "Go to dashboard",
                            type: BUTTON_TYPE.PRIMARY,
                            customStyle: {},
                            onClickCb: () => navigate(`/`),
                        },
                        {
                            label: "Go to filing history",
                            type: BUTTON_TYPE.PRIMARY,
                            customStyle: {},
                            onClickCb: () => {
                                const filingHistoryQueryObj = {
                                    [HISTORY_QUERY_PARAMS.PAGE]: FILING_HISTORY_VALUE,
                                };
                                const filingHistoryQueryStr = General.convertObjToQueryString(filingHistoryQueryObj);
                                navigate(`/${HISTORY_SECTION_ROUTES.HISTORY}?${filingHistoryQueryStr}`);
                            },
                        },
                    ]}
                />
            }


            {
                submitFormForMultiplePayers &&
                <SubmitFormForMultiplePayers
                    isOpen={submitFormForMultiplePayers}
                    onCloseCb={() => dispatch(setSubmitFormForMultiplePayers(false))}
                    selectedForm={selectedForm}
                    taxYear={selectedTaxYear?.label}
                />
            }

            {
                submitForRecipientPendingModal && 
                <ConfirmationPopup
                    bodyText={`The recipients listed below have TIN Matches pending. Click Cancel to wait for the TIN Match results before E-filing or OK to continue with the E-file. If the E-file occurs on a future date, you can edit the forms to update TIN or Name information after the TN Match results are available.`}
                    isOpen={submitForRecipientPendingModal}
                    confirmationButtonProps={{
                        onConfirmationCb: () => {
                            dispatch(setSubmitForRecipientPendingModal(false));
                            dispatch(setSubmitForThisPayerWarningModal(true));
                        },
                        confirmationButtonText: "Ok",
                        confirmationButtonStyles: {},
                        confirmationButtonType: BUTTON_TYPE.PRIMARY,
                    }}
                    cancelButtonProps={{
                        onCancelCb: () => dispatch(setSubmitForRecipientPendingModal(false)),
                        cancelButtonText: "Cancel",
                        cancelButtonStyles: {},
                        cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                    }}
                    showClose={false}
                />
            }
            {
                submitForThisPayerWarningModal &&
                <ConfirmationPopup
                    bodyText={`You have not chosen either USPS Mail or eDelivery. You may use Manage Forms to send email, USPS mail, or print copies of the Recipient 1099/W2. Click Cancel to make those selections now or OK if you plan to notify the Recipient separately.`}
                    // iconName={VEC_ICON_NAME.WARNING_ICON}
                    isOpen={submitForThisPayerWarningModal}
                    confirmationButtonProps={{
                        onConfirmationCb: () => {
                            if(selectedTaxYear.ID == 2024) {
                                dispatch(setSubmitForThisPayerWarningModal(false));
                                dispatch(setOpen2023PaymentModal(true))
                            } else {
                                dispatch(setSubmitForThisPayerWarningModal(false));
                                dispatch(setSubmitForThisPayerReviewedCheckboxModal(true));
                            }
                        },
                        confirmationButtonText: "Ok",
                        confirmationButtonStyles: {},
                        confirmationButtonType: BUTTON_TYPE.PRIMARY,
                    }}
                    cancelButtonProps={{
                        onCancelCb: () => dispatch(setSubmitForThisPayerWarningModal(false)),
                        cancelButtonText: "Cancel",
                        cancelButtonStyles: {},
                        cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                    }}
                    showClose={false}
                />
            }

            {
                submitForThisPayerReviewedCheckboxModal && <Popup
                    isPopupOpen={submitForThisPayerReviewedCheckboxModal}
                    childrenStyles={styles.modalBody}
                    onCloseCb={() => {
                        dispatch(setSubmitForThisPayerReviewedCheckboxModal(false))
                        dispatch(setSubmitForThisPayerReviewedCheckbox(false));
                    }}
                >
                    <Loadable
                        currentState={loadingState.state}
                        loadingStates={[FETCHING_LOAD_FORMS_DATA_FROM_DRAWER_LOADING]} isNewLoadable={true}
                        messageMap={FORM_LISTING_MESSAGE_MAP}
                    >
                        <CheckboxWLabel
                            checked={submitForThisPayerReviewedCheckbox}
                            label="I have reviewed and verified the data for submission"
                            onChangeCb={(e) => dispatch(setSubmitForThisPayerReviewedCheckbox(e.target.checked))}
                        />

                        <Button
                            style={styles.okButton}
                            disabled={!submitForThisPayerReviewedCheckbox}
                            onClickCb={() => {
                                dispatch(setSubmitForThisPayerModal(true))
                                dispatch(setSubmitForThisPayerReviewedCheckboxModal(false))
                                dispatch(setSubmitForThisPayerReviewedCheckbox(false));
                            }}>Ok</Button>
                    </Loadable>
                </Popup>
            }

            {
                assignFormsToReviewersModal && <AssignMembersTable
                    isPopup={true}
                    isPopupOpen={assignFormsToReviewersModal}
                    title='Assign Forms to Reviewer(s)'
                    payerDetails={selectedPayer}
                    onPopupCloseCb={() => dispatch(setAssignFormsToReviewersModal(false))}
                    onAssignCb={(selectedReviewers) => dispatch(assignFormToReviewers({
                        formIds: [highlightedForm?.FormId],
                        payerId: selectedPayer?.PayerDetailId,
                        formName: selectedForm?.FormLabel,
                        payerName: selectedPayer?.LastName,
                        taxyear: selectedTaxYear?.ID,
                        formtypeId: selectedForm?.Id,
                        reviewerIds: selectedReviewers,
                    }))}
                />
            }

            {
                open1094cModal && <Form1094c isPopupOpen={open1094cModal} handlePopupClose={() => dispatch(setOpen1094cModal(false))} selectedForm={selectedForm} payer={selectedPayer} year={selectedTaxYear?.value} onFinalSubmitCb={() => dispatch(setCheckFor1094cStatus(true))} isEditModeOn={(form1094cStatusObj?.isAvailable && form1094cStatusObj?.formStatus) ? true : false} />
            }

            {
                open2023PaymentModal && <InformationPopup
                isOpen={open2023PaymentModal} 
                title={'Attention'} 
                isClose={false}
                confirmationButtonProps={{
                    onConfirmationCb: () => {
                        dispatch(setOpen2023PaymentModal(false));
                        dispatch(setSubmitForThisPayerReviewedCheckboxModal(true));
                    },
                    confirmationButtonText: "Ok",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                >
                    <span>
                        The IRS FIRE System is down for their annual year end maintenance. The IRS will not process forms through the FIRE System starting <strong>November 27, 2023 - January 7, 2024</strong>. At this time, the IRS has scheduled the FIRE System to become available again on <strong>January 8, 2024</strong>. This will be the earliest date the forms will start being processed again by the IRS for previous tax years as well as the 2023 tax year.
                        Please understand that any submissions of the forms prior to <strong>January 8, 2024</strong>. will not begin to be processed until the date the IRS FIRE System comes back online. Please take that date into consideration when waiting for IRS acceptance of your forms. Thank you !
                    </span>
                </InformationPopup>
            }

        </>
    )
}